import { api } from 'api/api';
import { Endpoints } from 'api/constants';
import { TableDataResponse } from 'types/general';
import { IFeedbackItem } from 'types/income';
import { exportXlsxConfig, getSorting } from 'utils/general';
import { FeedbackFilters, FeedbackStatus } from './feedback.types';

const getFilters = (filters: Partial<FeedbackFilters>) => ({
  page: filters.page,
  pageSize: filters.pageSize,
  ...getSorting(filters.sort),
  search: filters.search || undefined,
  filter: {
    status: filters.status,
    entity: filters.entity,
    subjectIds: filters.entityIds,
    employeeIds: filters.employees,
    dateFrom: filters.date?.from,
    dateTo: filters.date?.to,
  },
});

interface GetFeedbackItems {
  filters: Partial<FeedbackFilters>;
}

interface GetDiscountFeedbackItems {
  filters: Partial<FeedbackFilters>;
}

interface GetFeedbackItem {
  feedbackId: string;
}

interface UpdateFeedbackItem {
  feedbackId: string;
  data: Partial<{
    title: string;
    status: FeedbackStatus;
    adminNotes: string;
  }>;
}

interface BulkDeleteFeedback {
  ids: string[];
}

interface BulkUpdateFeedbackStatus {
  ids: string[];
  status: FeedbackStatus;
}

interface ExportXlsDiscountFeedbackItems {
  filters: Partial<FeedbackFilters>;
}

export const loaders = {
  getFeedbackItems: ({ filters }: GetFeedbackItems) => {
    return api<TableDataResponse<IFeedbackItem>>({
      url: Endpoints.feedback.root,
      context: 'melp',
      params: {
        ...getFilters(filters),
      },
    });
  },
  getDiscountFeedbackItems: ({ filters }: GetDiscountFeedbackItems) => {
    return api<TableDataResponse<IFeedbackItem>>({
      url: Endpoints.melpAdmin.discounts.feedback.root,
      context: 'melp',
      params: {
        ...getFilters(filters),
      },
    });
  },
  getFeedbackItem: ({ feedbackId }: GetFeedbackItem) => {
    return api<IFeedbackItem>({
      url: Endpoints.feedback.byId.replace(':feedbackId', feedbackId),
      context: 'melp',
    });
  },
  updateFeedbackItem: ({ feedbackId, data }: UpdateFeedbackItem) => {
    return api<{ id: string }>({
      url: Endpoints.feedback.byId.replace(':feedbackId', feedbackId),
      context: 'melp',
      data: {
        ...data,
      },
      method: 'patch',
    });
  },
  bulkUpdateFeedbackStatus: ({ ids, status }: BulkUpdateFeedbackStatus) => {
    return api({
      url: Endpoints.feedback.bulk.status,
      context: 'melp',
      data: { ids, status },
      method: 'patch',
    });
  },
  bulkDeleteFeedback: ({ ids }: BulkDeleteFeedback) => {
    return api({
      url: Endpoints.feedback.bulk.root,
      context: 'melp',
      data: { ids },
      method: 'delete',
    });
  },
  exportXlsDiscountFeedbackItems: ({
    filters,
  }: ExportXlsDiscountFeedbackItems) => {
    const { pageSize, page, sorting, ...params } = getFilters(filters);

    return api({
      url: Endpoints.melpAdmin.discounts.feedback.export.xls,
      context: 'melp',
      params,
      ...exportXlsxConfig,
    });
  },
};
